module.exports = __webpack_public_path__ + "img/natural_waist.cdab2811.png";